module.exports = __webpack_public_path__ + "static/sport/game-4.219bc06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/game-4.png
// module id = HMzI
// module chunks = 0